import { render, staticRenderFns } from "./ArchiveResultsHeader.vue?vue&type=template&id=5a41f163&scoped=true&"
import script from "./ArchiveResultsHeader.vue?vue&type=script&lang=js&"
export * from "./ArchiveResultsHeader.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveResultsHeader.vue?vue&type=style&index=0&id=5a41f163&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a41f163",
  null
  
)

export default component.exports